export default __webpack_public_path__ + "static/lic-nova-w600-b8f139affa87f5d589dad82ac5c68a6b.jpg";